import { render, staticRenderFns } from "./Buchhaltung.vue?vue&type=template&id=069e4250&"
import script from "./Buchhaltung.vue?vue&type=script&lang=js&"
export * from "./Buchhaltung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports